/**
 *
 * withAlerts
 * HOC to add alertservice
 *
 */

// import React from 'react';
// import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import makeSelectAlertService from './selectors';
import { addAlert, dismissAlert } from './actions';

const mapStateToProps = createStructuredSelector({
  alerts: makeSelectAlertService(),
});

function mapDispatchToProps(dispatch) {
  return {
    addAlert: options => dispatch(addAlert(options)),
    dismissAlert: id => dispatch(dismissAlert(id)),
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export default withConnect;
